import { LayoutTemplate } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function TemplateCard({ template, values, onChange }) {
  if (!template) return null;
  return (
    <section className="rounded-xl border border-primary/25 bg-secondary/40 p-5 sm:p-6" data-testid="template-card">
      <div className="flex items-center gap-2 mb-1">
        <LayoutTemplate className="h-4 w-4 text-primary" />
        <h3 className="text-base font-semibold text-slate-900" data-testid="template-name">{template.name}</h3>
        <span className="font-mono text-[11px] px-2 py-0.5 rounded bg-white text-teal-800 border border-teal-200">{template.code}</span>
      </div>
      <p className="text-xs text-slate-500 mb-4">Template for this billing code — the AI follows this layout when drafting.</p>
      <div className="space-y-3">
        {template.fields.map((f) => (
          <div key={f.key} className="space-y-1.5">
            <Label className="text-xs">{f.label}</Label>
            <Input
              value={values[f.key] || ""}
              onChange={(e) => onChange({ ...values, [f.key]: e.target.value })}
              placeholder={f.placeholder}
              className="bg-white h-9 text-sm"
              data-testid={`template-field-${f.key}`}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
